// @flow

//
// React
//
import React, { type Node } from 'react';

//
// Components
//
import {
    TextFloatPaneField,
} from '../../../trix-web-components-pane';

//
// Props
//
type Props = {
    //
    // State
    //
    label: string,

    //
    // Data
    //
    data: any,
}; // End of Props

//
// Component
//
const FloatPaneCustomerField = (props: Props): Node => {
    // Hooks
    // const classes = useStyles();
    // End Hooks

    const code = (props.data && props.data.code) ? props.data.code : '';
    const name = (props.data && props.data.name) ? props.data.name : '';

    return (
        <TextFloatPaneField
            label={props.label}
            value={`${code} / ${name}`}
        />
    );
};
export default FloatPaneCustomerField;
